import { render } from "./Work.vue?vue&type=template&id=0686e2e4&ts=true"
import script from "./Work.vue?vue&type=script&lang=ts"
export * from "./Work.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\工作\\前端代码\\康庭后台\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__